import { generateURL } from 'utils/helpers';

const resource = {
  getResourceByID: (id) => {
    const url = generateURL(`/resource/${id}`);
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to get resource'));
      }
      return response.json();
    });
  },
};

export default resource;
